import { render, staticRenderFns } from "./Dollars.vue?vue&type=template&id=6d214d2a&scoped=true&"
import script from "./Dollars.vue?vue&type=script&lang=js&"
export * from "./Dollars.vue?vue&type=script&lang=js&"
import style0 from "./Dollars.vue?vue&type=style&index=0&id=6d214d2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d214d2a",
  null
  
)

export default component.exports